import { Audio_SAMPLE_RATE } from "./audio_utils";

/**
 * 20 millisecond audio silence string BASE_64_PCM_16
 * it is used so that first few words are not missed
 */
const SILENCE_AUDIO_STRING="AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA"
/**
 * This class plays base 64 audio that is being streamed from 
 * websocket from backend opeAI response
 */
class AudioStreamPlayer {
    constructor() {
      this.audioContext = null;
      this.audioQueue = []; // FIFO Queue for audio chunks
      this.isPlaying = false;
      //this.printed=false;
    }
  
    /**
     * Adds a new Base64 audio chunk to the queue
     * @param {string} base64Chunk - Base64 encoded audio chunk
     */
    addAudioChunk(base64Chunk) {
      if(!base64Chunk) return  
      
      if(!this.audioContext){
        this.audioContext=new (window.AudioContext || Window.webkitAudioContext)();
      }

       /* first chunk is pushed multiple times because
       audio Started playing only after one or two chunks,
       */
      if(this.audioQueue.length==0){
        //this.audioQueue.push(base64Chunk);
        //this.audioQueue.push(base64Chunk);
       //console.log("pushed audio chunks actually two extra times")
        // add silence string a few times - 10
       // for(let i=0;i<40;i++)
       //   this.audioQueue.push(SILENCE_AUDIO_STRING);
      }
      this.audioQueue.push(base64Chunk);
      this.playNextChunk();
     
    }
  
    /**
     * Plays the next audio chunk if available and not already playing
     */
    async playNextChunk() {
      if (this.isPlaying || this.audioQueue.length === 0) return;
  
      this.isPlaying = true;
      const base64Chunk = this.audioQueue.shift(); // Get first chunk
     
      try {
        const audioBuffer = await this.base64PCM16ToAudioBuffer(base64Chunk)
        this.playAudioBuffer(audioBuffer);
      } catch (error) {
        console.log("Error decoding or playing audio:", error);
        this.isPlaying = false;
        this.playNextChunk(); // Try next chunk if decoding fails
      }
    }
  
    // sample rate of 24KHZ is taken from openai tts page
  async base64PCM16ToAudioBuffer(base64String, sampleRate = Audio_SAMPLE_RATE) {
        // Decode base64 string to binary
        const binaryString = atob(base64String);
        const len = binaryString.length;
        const buffer = new ArrayBuffer(len);
        const view = new Uint8Array(buffer);
      
        for (let i = 0; i < len; i++) {
          view[i] = binaryString.charCodeAt(i);
        }
      
        // Convert PCM16 data to Float32Array
        const pcm16Array = new Int16Array(buffer);
        const float32Array = new Float32Array(pcm16Array.length);
      
        for (let i = 0; i < pcm16Array.length; i++) {
          float32Array[i] = pcm16Array[i] / 0x8000; // Normalize PCM16 to Float32 (-1 to 1)
        }
      
        // Create an AudioBuffer using Web Audio API
        //const audioContext = new (window.AudioContext || window.webkitAudioContext)();
        const audioBuffer = this.audioContext.createBuffer(1, float32Array.length, sampleRate);
        audioBuffer.getChannelData(0).set(float32Array);
      
        return audioBuffer;
      }    
  
    /**
     * Plays an AudioBuffer and moves to the next chunk after completion
     * @param {AudioBuffer} audioBuffer
     */
    playAudioBuffer(audioBuffer) {
      const source = this.audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(this.audioContext.destination);
  
      source.onended = () => {
        this.isPlaying = false;
        this.playNextChunk(); // Continue playing next chunk
      };
  
      source.start();
    }
  
    /**
     * Clears the audio queue
     */
    clearQueue() {
      this.audioQueue = [];
    }
  
    /**
     * Stops playback immediately
     */
    stopPlayback() {
      if (this.audioContext) {
        this.audioContext.close().then(() => {
          this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
          this.isPlaying = false;
        });
      }
    }
  }
  
  export default AudioStreamPlayer;
  